import * as React from 'react';
import { DeleteForm } from '../DeleteForm';
import { useAccountantDeleteForm } from './useAccountantDeleteForm';

export const AccountantDeleteForm = () => {
  const { onSubmit, inProgress } = useAccountantDeleteForm();
  return (
    <DeleteForm
      onSubmit={onSubmit}
      inProgress={inProgress}
      headerText={'Biztos hogy törli ezt a könyvelőt?'}
      submitText={'Törlés'}
    />
  );
};
